import * as React from "react";
import {FormGroupProps} from "../../common/props/FormGroupProps";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";
import {option, Option} from "ts-option";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import {PartnerBrandSearch} from "../../../model/partnerBrand/PartnerBrand";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import PartnerBrandSelectionComponent from "../../partnerBrand/search/PartnerBrandSelectionComponent";
import {Dispatch} from "redux";
import {fetchPartnerBrands, savePartnerBrandSearch} from "../../../store/action/partnerBrand/partnerBrand";
import {OnFailure} from "../../../store/action/actionHelpers";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";

interface IComponentProps {
	brandId: Option<string>;
	disabled?: boolean;
}

interface ReduxProps {
	selectedValue: Option<PartnerBrandSearch>
}

interface DispatchProps {
	storePartnerBrandSearch: (pb: PartnerBrandSearch) => void
	fetchPartnerBrand: (pbId: string, onFailure: OnFailure) => void
}

type Props = FormGroupProps<string> & PlaceholderProps & IComponentProps & ReduxProps & DispatchProps

/**
 * Partner brand form view group.
 */
class PartnerBrandFormGroup extends React.PureComponent <Props> {
	constructor(props: Props) {
		super(props);
		this.onChange = this.onChange.bind(this);
	}

	componentDidMount(): void {
		this.fetchPartnerBrand()
	}

	componentWillReceiveProps(nextProps: Readonly<Props>): void {
		this.fetchPartnerBrand(nextProps)
	}

	fetchPartnerBrand(props = this.props) {
		if (props.field.getOptionalValue().isDefined && props.selectedValue.isEmpty) {
			props.field.getOptionalValue().map(
				pbId => this.props.fetchPartnerBrand(pbId, e => notifyBugsnagAndShowToast(e, "Fetch partner brand")))
		}
	}

	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<PartnerBrandSelectionComponent placeholder={this.props.placeholder}
												disabled={this.props.disabled}
												clearable={true}
												brandId={this.props.brandId.orNull}
												onSelect={this.onChange}
												selectedValue={this.props.selectedValue}/>
			</FormGroup>
		);
	}

	/**
	 * Callback on changed partner brand.
	 * @param data
	 */
	onChange(data: Option<PartnerBrandSearch>) {
		this.props.onChange(this.props.field.updateValue(data.map((pb) => pb.id)))
		data.map(this.props.storePartnerBrandSearch)
	}
}


function mapStateToProps(state: RootState, props: FormGroupProps<string>) {
	let selectedValue = option(state.partnerBrand.partnerBrandsSearchMap[props.field.getOptionalValue().orNull]);
	return {
		selectedValue
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		storePartnerBrandSearch: (pb: PartnerBrandSearch) => dispatch(savePartnerBrandSearch(pb)),
		fetchPartnerBrand: (pbId: string, onFailure: OnFailure) => dispatch(fetchPartnerBrands([pbId], () => {}, onFailure))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(PartnerBrandFormGroup);